var $ = require('jquery');

var QuoteForm = function QuoteForm($element) {
	$radioButtons = $element.find('input[type="radio"], input[type="checkbox"]');

	$radioButtons.filter(':not([name="translation-direction"])').first().parents('.primary-radio').addClass('-active');

	$radioButtons.on('click', function() {
		var $button = $(this).parents('.primary-radio');

		if(!$button.hasClass('-active') || !$button.siblings('.primary-radio').length) {
			$button.toggleClass('-active').siblings('.primary-radio').removeClass('-active');
		}
	});
}

module.exports = QuoteForm;